import React from "react";
import { FaLink, FaGithub } from "react-icons/fa";
// import "./ProjectCard.css";

function ProjectCard({ title, desc, langs, liveLink, githubLink }) {
  return (
    <div className="main">
      <div
        class="card d-flex justify-content-center align-items-center w-50 mx-auto mt-2 mb-5"
        style={{ background: "#23292e", border: "2px solid #3ab755" }}
      >
        <div class="card-body d-flex justify-content-center align-items-center flex-column">
          <h3 class="card-title" style={{ color: "#8da2ff" }}>
            {title}
          </h3>
          <p class="card-text">{desc}</p>

          <div style={{ marginRight: "10px" }}>
            <a href={githubLink} target="_blank">
              <FaGithub
                className="git"
                style={{ height: "20px", width: "20px",marginRight:'15px' }}
              />
            </a>
            <a href={liveLink} target="_blank">
              <FaLink
                className="link"
                style={{ height: "20px", width: "20px" }}
              />
            </a>
          </div>

          <div style={{ color: "#d8ff00", display: "flex", marginTop: "10px" }}>
            {langs.map((lang) => (
              <div
                className="card"
                style={{
                  background: "none",
                  border: "2px solid orange",
                  marginRight: "15px",
                }}
                key={Math.random()}
              >
                {"   "}
                {lang}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectCard;
